import { render, staticRenderFns } from "./ReportSendToTW.vue?vue&type=template&id=41b6f261&"
import script from "./ReportSendToTW.vue?vue&type=script&lang=js&"
export * from "./ReportSendToTW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports